import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 合同客户列表
export const getCustomerGroupInfoPage = (params) => {
    return request({
        url: apiCrmHost + '/customer/group/info/page',
        method: 'get',
        params
    });
};
// 属地客户经理查询-rzq
export const getLocalCustomerManager = (data) => {
    return request({
        url: apiCrmHost + '/customer/local/manager/query/page',
        method: 'post',
        data
    });
};
// 属地客户经理保存-rzq
export const saveLocalCustomerManager = (data) => {
    return request({
        url: apiCrmHost + '/customer/local/manager/save',
        method: 'post',
        data
    });
};
// 属地客户经理废弃-rzq
export const abandonLocalCustomerManager = (data) => {
    return request({
        url: apiCrmHost + '/customer/local/manager/del',
        method: 'post',
        data
    });
};
// 属地客户经理控权-rzq
export const authLocalCustomerManager = (data) => {
    return request({
        url: apiCrmHost + '/customer/local/manager/auth',
        method: 'post',
        data
    });
};
// 属地客户经理导出-rzq
export const exportLocalCustomerManager = (data) => {
    return request({
        url: apiCrmHost + '/customer/local/manager/export',
        method: 'post',
        data
    });
};
// 属地客户经理导入-rzq
export const importLocalCustomerManager = (data) => {
    return request({
        url: apiCrmHost + '/customer/local/manager/import',
        method: 'post',
        data
    });
};
// 属地客户经理变更日志-rzq
export const getLocalCustomerManagerHistoryList = (data) => {
    return request({
        url: apiCrmHost + '/customer/group/local/manager/his/query/page',
        method: 'post',
        data
    });
};
